import React from 'react'

export default function Lines(){
   return (
     <ul className="lines">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
    </ul>
  );
}
